import React, { useEffect, useState } from 'react';
import api from '../api';

export default function Dashboard() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/summary')
      .then(res => { setSummary(res.data); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, []);

  if (loading) return <div className="loading">Loading dashboard...</div>;
  if (error) return <div className="alert alert-error">{error}</div>;

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">DASH<span>BOARD</span></h2>
        <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-muted)' }}>
          {new Date().toLocaleDateString('en-GB', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </span>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Total Customers</div>
          <div className="stat-value">{summary.customers?.total ?? '—'}</div>
          <div className="stat-sub">{summary.customers?.active ?? 0} active</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Open Quotes</div>
          <div className="stat-value">{summary.quotes?.open ?? '—'}</div>
          <div className="stat-sub">awaiting response</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Pipeline Value</div>
          <div className="stat-value">
            £{Number(summary.opportunities?.total_value ?? 0).toLocaleString('en-GB', { maximumFractionDigits: 0 })}
          </div>
          <div className="stat-sub">{summary.opportunities?.open ?? 0} open opportunities</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Low Stock Alerts</div>
          <div className="stat-value" style={{ color: summary.inventory?.low_stock > 0 ? 'var(--danger)' : 'var(--success)' }}>
            {summary.inventory?.low_stock ?? 0}
          </div>
          <div className="stat-sub">items below threshold</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <div className="card">
          <div className="card-header">Quick Links</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <a href="/customers" className="btn btn-secondary">◈ &nbsp;View Customers</a>
            <a href="/sales" className="btn btn-secondary">◎ &nbsp;View Sales</a>
            <a href="/projects" className="btn btn-secondary">⬡ &nbsp;View Projects</a>
            <a href="/inventory" className="btn btn-secondary">▣ &nbsp;View Inventory</a>
          </div>
        </div>
        <div className="card">
          <div className="card-header">System Status</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {[
              { label: 'API', status: 'Online' },
              { label: 'Database', status: 'Online' },
              { label: 'Backups', status: 'Running' },
            ].map(item => (
              <div key={item.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-secondary)' }}>{item.label}</span>
                <span className="badge badge-active">{item.status}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}